import { PLUS_PLAN_HANDLE, PRO_PLAN_HANDLE } from 'constants/billing';
import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import { useShopPlanInfo } from 'hooks/useShopPlanInfoStatus';
import { useMemo } from 'react';

export interface UpgradePlan {
    /** Displayed plan name from the plans list, e.g. "Pro" — empty until the plans have loaded */
    name: string;
    /** `handle` of the Shopify pricing plan, e.g. "pro" */
    handle: string;
    /** Free trial length of the plan in days, from the plans list — 0 until the plans have loaded */
    trialDays: number;
}

/**
 * The plan to upgrade to: Plus for Shopify Plus stores, Pro otherwise. The name and trial length come
 * from the matching plan in the Shopify plans list.
 */
export const useUpgradePlan = (): UpgradePlan => {
    const { isShopifyPlusUser } = useShopPlanInfo();
    const { plans } = useCurrentSubscriptionHelper();

    // TODO: when available, get the handle from the plans instead of the hardcoded constants
    return useMemo(() => {
        const handle = isShopifyPlusUser ? PLUS_PLAN_HANDLE : PRO_PLAN_HANDLE;
        const plan = plans.find((p) => p.handle === handle);

        return {
            handle,
            // Empty until the plans have loaded (or if no plan has this handle)
            name: plan?.name ?? '',
            trialDays: plan?.trialDays ?? 0,
        };
    }, [isShopifyPlusUser, plans]);
};
